import { Directive, ViewContainerRef, ComponentRef, OnInit, OnDestroy } from '@angular/core';
import { ToasterService, ToastOptions } from '../services/toaster.service';
import { Subject } from 'rxjs';
import { ToastComponent } from '../components/toast/toast.component';
import { takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[appToaster]',
    standalone: false
})
export class ToasterDirective implements OnInit, OnDestroy {
    private ref: ComponentRef<ToastComponent>;
    private destroy = new Subject<void>();

    constructor(
        private viewContainerRef: ViewContainerRef,
        private toaster: ToasterService
    ) {}

    ngOnInit() {
        this.toaster.eject$.pipe(takeUntil(this.destroy)).subscribe((output) => {
            this.close();
            if (output == null) {
                return;
            }
            this.open(output);
        });

        this.toaster.close$.pipe(takeUntil(this.destroy)).subscribe((_) => {
            this.close();
        });
    }

    ngOnDestroy() {
        this.close();
        this.destroy.next();
        this.destroy.unsubscribe();
    }

    open(output: { message: string; title?: string; options?: ToastOptions }) {
        this.ref = this.viewContainerRef.createComponent(ToastComponent);
        this.ref.instance.message = output.message;
        this.ref.instance.title = output.title;
        this.ref.instance.options = output.options;
        this.viewContainerRef.element.nativeElement.appendChild(this.ref.location.nativeElement);
    }

    close() {
        if (this.ref != null) {
            this.ref.destroy();
            this.ref.location.nativeElement.remove();
            this.ref = null;
            this.toaster.close();
        }
    }
}
